import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { DateTimeStandard, Icons, IconButton, Menu, MenuItem, ListItemText } from "@curves/ui-base";
import { CLUB_APPOINTMENT_ROUTER } from '@icoach/router/routerPath';
import useAppointment from '@icoach/appointment/components/useAppointment';
import { parseDate } from '@util/moment';

const AppointmentOverviewMoreMenuOption = React.forwardRef((props, ref) => {
    const { apoId, peopleType, peopleID, name, nickName, appointmentDate, appointmentTime } = props;
    const { dialogRef } = useAppointment();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMoreIconClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = (e) => {
        setAnchorEl(null);
    };

    const handleMenuAction = (target) => {
        if (target === 'sms') {
            const combinedString = `${appointmentDate} ${appointmentTime}`;
            const apoDateTime = parseDate(combinedString, DateTimeStandard.DisplayFullBySlash);
            const params = { id: peopleID, type: peopleType, name: nickName || name, appointmentID: apoId, apoDateTime };
            dialogRef.current && dialogRef.current.openSmsDialog && dialogRef.current.openSmsDialog(params);
        } else if (target === 'contact') {
            dialogRef.current &&
                dialogRef.current.openAppointmentContactDialog &&
                dialogRef.current.openAppointmentContactDialog({
                    appointmentID: apoId,
                    peopleID,
                    peopleType,
                });
        }
        setAnchorEl(null);
    };

    return (
        <React.Fragment>
            <IconButton onClick={handleMoreIconClick}>
                <Icons.MoreVertical />
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={(e) => handleClose(null)}>
                <MenuItem onClick={() => handleMenuAction()} to={CLUB_APPOINTMENT_ROUTER.GET_INFORMATION_PATH(apoId)} component={NavLink}>
                    <ListItemText>編輯/查看</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => handleMenuAction('contact')}>
                    <ListItemText>新增聯繫</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => handleMenuAction('sms')}>
                    <ListItemText>發送簡訊</ListItemText>
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
});

export default AppointmentOverviewMoreMenuOption;
